/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyDto } from './companyDto';


export interface FullVersionWaitingListItemDto { 
    id?: number;
    invoiceNumberMonthly?: number;
    numberOfOffices?: number;
    exclusiveRadius?: number;
    exclusiveDuration?: number;
    exclusiveCustomPrice?: number;
    status?: FullVersionWaitingListItemDto.StatusEnum;
    company?: CompanyDto;
}
export namespace FullVersionWaitingListItemDto {
    export type StatusEnum = 'PENDING' | 'APPROVED' | 'REJECTED';
    export const StatusEnum = {
        Pending: 'PENDING' as StatusEnum,
        Approved: 'APPROVED' as StatusEnum,
        Rejected: 'REJECTED' as StatusEnum
    };
}


